module.exports = __webpack_public_path__ + "img/Jason.89913c92.png";